import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../blocks/heigh-educate-banner";
import { HeighEducateChallenge } from "../../blocks/customer-heigh-educate-challenge";
import { HeighEducateIdea } from "../../blocks/customer-heigh-educate-idea";
import { CustomerConsult } from "../../blocks/common-customer-consult";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../blocks/customer-detail-intro";
import { Footer } from "../../components/FooterV2";
import { Helmet } from "react-helmet";

export const DeephowPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.deephow.challenge.item1.title"),
      description: t("customer.deephow.challenge.item1.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.deephow.ideas.item1.title"),
      descript: t("customer.deephow.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.deephow.ideas.item2.title"),
      descript: t("customer.deephow.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
  ];
  return (
    <div className="deephow-page">
      <Helmet>
        <title>
          PingCAP
          SSO单点登录案例_PingCAP统一身份认证客户案例-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.deephow.banner.title")}
        addtionTitle={t("customer.deephow.banner.addtionTitle")}
        subtitle={t("customer.deephow.banner.subtitle")}
        theme="#5787EC"
        imgUrl={
          "//files.authing.co/authing-website/customer-deephow-tiny-new.png"
        }
      />
      <CustomerDetailIntro
        imgUrl={t("customer.deephow.intro.imgUrl")}
        content={
          <>
            <p>{t("customer.deephow.intro.descript1")}</p>
            <p>{t("customer.deephow.intro.descript2")}</p>
          </>
        }
      />
      <HeighEducateChallenge
        challenges={challenges}
        // scale={{ 350: 1, 750: 1, 900: 1, 1200: 1 }}
        scale={{ 1200: 1 }}
        theme="#5787EC"
      />
      <HeighEducateIdea
        ideas={ideas}
        // scale={{ 350: 1, 750: 1, 900: 2, 1200: 2 }}
        scale={{ 1200: 2 }}
        theme="#5787EC"
      />
      <CommonPageLink pagesLink={pagesLink} />
      <CustomerConsult />
      <Footer />
    </div>
  );
};
